import { createAction } from '@reduxjs/toolkit';

export const collectionBreadCrumbsActions = {
  navigateTo: createAction<{ navigateTo: string }>('CollectionBreadCrumbs/NavigateTo'),
};
